import { render, staticRenderFns } from "./RuleSettings.vue?vue&type=template&id=9a9d0b7e&scoped=true&"
import script from "./RuleSettings.vue?vue&type=script&lang=ts&"
export * from "./RuleSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RuleSettings.vue?vue&type=style&index=0&id=9a9d0b7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9d0b7e",
  null
  
)

export default component.exports